import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-bold" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "font-bold" }

import { Button } from '@/components/ui/button';
    import {
        Dialog,
        DialogContent,
        DialogHeader,
        DialogTitle,
        DialogClose,
        DialogFooter,
        DialogDescription,
        DialogBody,
    } from '@/components/ui/dialog';
    import { computed, ref } from 'vue';
    import { useI18n } from 'vue-i18n';
    import type { Payslip } from '@/types';
    import { toast } from 'vue-sonner';
    import { useForm } from '@inertiajs/vue3';
    import { InputRow } from '@/components/ui/form';
    import { Textarea } from '@/components/ui/textarea';
    import { useDateFormat } from '@/composables/useDateFormat';

    import QueryKey from '@/enums/QueryKey';
    import { useQueryClient } from '@tanstack/vue-query';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PayslipSendReminder',
  props: {
    payslip: {},
    modelValue: { type: Boolean },
    selectedCompanyId: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const { formatDMYFromIso } = useDateFormat();

    const queryClient = useQueryClient();

    const props = __props;

    const emit = __emit;

    const open = computed({
        get: () => props.modelValue ?? false,
        set: (value) => emit('update:modelValue', value),
    });

    const { t } = useI18n();

    const form = useForm({
        paySlips: [props.payslip.id],
        comment: '',
    });

    const sendReminder = () => {
        form.post(route('v2.salary.payslip.reminder', { company: props.selectedCompanyId }), {
            preserveScroll: true,
            onSuccess: () => {
                form.resetAndClearErrors();
                toast.success(t('mails.success'));
                queryClient.invalidateQueries({
                    queryKey: [QueryKey.PAYROLLS, props.selectedCompanyId],
                });
                handleClose();
            },
            onError: (error: any) => {
                if (error instanceof Error) {
                    toast.error(t('forms.system_error'));
                }
            },
        });
    };

    const handleClose = () => {
        open.value = false;
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: open.value,
    "onUpdate:open": _cache[1] || (_cache[1] = (value) => (open.value = value))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "sm:max-w-lg" }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            class: "flex max-h-full flex-col overflow-hidden",
            onSubmit: _withModifiers(sendReminder, ["prevent"])
          }, [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('pay-slips.confirm.title')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(DialogBody), { class: "space-y-5" }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogDescription), { class: "space-y-2" }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString(_unref(t)('pay-slips.confirm.involved')) + " ", 1),
                      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.payslip.payroll.month) + "/" + _toDisplayString(_ctx.payslip.payroll.year), 1)
                    ]),
                    (_ctx.payslip.last_reminded_at)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                          _createTextVNode(_toDisplayString(_unref(t)('pay-slips.confirm.last_reminded_at')) + " ", 1),
                          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(formatDMYFromIso)(_ctx.payslip.last_reminded_at)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(InputRow), {
                  form: _unref(form),
                  name: "comment",
                  label: "pay-slips.comment"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Textarea), {
                      id: "comment",
                      modelValue: _unref(form).comment,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).comment) = $event)),
                      placeholder: _ctx.$t('pay-slips.confirm.comment')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["form"])
              ]),
              _: 1
            }),
            _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogClose), { "as-child": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      variant: "outline",
                      size: "sm",
                      onClick: handleClose
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('forms.close')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  disabled: _unref(form).processing,
                  loading: _unref(form).processing,
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('pay-slips.reminder-text')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]),
              _: 1
            })
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})